import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    openEditor: false,
  }),
  actions: {
    toggleEditor() {
      this.openEditor = !this.openEditor
    },
  },
})
